{
  "branding": {
    "frontdesk-attribution": "Mit FrontDesk+",
    "practice-logo": "Logo von {{name}}"
  },
  "validation": {
    "required": "Dieses Feld ist erforderlich",
    "invalid-url": "Bitte geben Sie eine gültige URL ein",
    "pin-too-short": "PIN muss mindestens 4 Zeichen lang sein",
    "pin-default-rejected": "Die Standard-PIN 0000 ist nicht erlaubt. Bitte vergeben Sie eine eigene PIN.",
    "invalid-kim-address": "Bitte geben Sie eine gültige KIM-Adresse ein (z. B. praxis@musterpraxis.kim.telematik)."
  },
  "onboarding": {
    "prepare": {
      "title": "Zuerst freischalten",
      "subtitle": "FrontDesk+ muss in Ihrer Praxis-Software freigeschaltet sein.",
      "step1": "Im SolStore bestellen (oder Ihr Doc-Cirrus-Partner bestellt für Sie).",
      "step2": "Nach der Freischaltung in inSuite unter „inSuite Sols“ aktivieren (Admin-Rechte).",
      "step3": "Bridge-Verwaltung öffnen → „Gerät hinzufügen“.",
      "cta": "Alles erledigt — weiter"
    },
    "welcome": {
      "title": "Dieses Gerät zur Praxis hinzufügen",
      "scan": "Code abfotografieren",
      "prepare-link": "Kein Code in inSuite?",
      "language": "Sprache"
    },
    "scan": {
      "requesting": "Kamerazugriff wird angefordert…",
      "scanning": "Richten Sie die Kamera auf den Code",
      "paste": "Stattdessen einfügen",
      "manual-title": "Manuell verbinden",
      "manual-description": "Falls der QR-Code nicht verfügbar ist, übernehmen Sie die Verbindungsdaten aus der Bridge-Verwaltung.",
      "address-label": "Bridge-Adresse",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "SOLTOKEN einfügen",
      "manual-submit": "Verbindung übernehmen",
      "error-title": "Code nicht erkannt",
      "camera-denied-title": "Kamerazugriff verweigert",
      "camera-denied-hint": "Bitte erlauben Sie den Kamerazugriff in den Einstellungen und versuchen Sie es erneut.",
      "retry": "Erneut versuchen"
    },
    "preflight": {
      "title": "Wird eingerichtet",
      "all-green": "Alle Prüfungen bestanden",
      "practice": "Praxis",
      "device-name": "Gerätename",
      "device-name-placeholder": "z. B. Empfang 1",
      "card-reader": "Kartenleser",
      "pin": "Neue Geheimzahl",
      "pin-placeholder": "Vierstellige PIN",
      "finish": "Fertigstellen",
      "recheck": "Erneut prüfen",
      "diagnosis": "Diagnose-ID",
      "checklist-error": "Die Bridge hat die Verbindung abgelehnt oder ist nicht erreichbar. Prüfen Sie SOLTOKEN und Bridge-Adresse.",
      "checklist-retry": "Erneut prüfen",
      "edit-token": "SOLTOKEN ändern",
      "rescan": "Code erneut scannen"
    },
    "persisting": "Einrichtung wird gespeichert …",
    "success": {
      "title": "Gerät hinzugefügt",
      "detail": "Das Gerät ist gerade auf dem Praxis-PC erschienen.",
      "starting": "Patientenmodus wird gestartet…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Verbindung zur Praxis-Software",
        "fix": "Bridge-Verbindung und Serveradresse prüfen."
      },
      "missing_insuite_url": {
        "label": "inSuite-Adresse",
        "fix": "Den QR-Code erneut scannen — die Adresse fehlt."
      },
      "missing_server_token": {
        "label": "Server-Token",
        "fix": "Den QR-Code erneut scannen — der Token fehlt."
      },
      "missing_gateway_session": {
        "label": "Gateway-Sitzung",
        "fix": "Erneut anmelden — die Sitzung fehlt."
      },
      "missing_gateway_enrollment": {
        "label": "Geräte-Anmeldung",
        "fix": "Gerät am Gateway anmelden."
      },
      "gateway_not_ready": {
        "label": "Gateway-Bereitschaft",
        "fix": "Warten, bis das Gateway die Einrichtung abschließt."
      },
      "token_verification_failed": {
        "label": "Token-Prüfung",
        "fix": "Server-Token oder Bridge-Verbindung prüfen."
      },
      "session_expired": {
        "label": "Sitzung",
        "fix": "Die Sitzung ist abgelaufen — erneut anmelden."
      },
      "device_revoked": {
        "label": "Gerätestatus",
        "fix": "Dieses Gerät wurde gesperrt. Wenden Sie sich an die Praxis."
      },
      "missing_practice_name": {
        "label": "Praxisname",
        "fix": "Praxisname konnte nicht aus inSuite geladen werden."
      },
      "missing_device_name": {
        "label": "Gerätename",
        "fix": "Bitte vergeben Sie einen Gerätenamen."
      },
      "telematik_unavailable": {
        "label": "Telematik-Infrastruktur",
        "fix": "Optional — Karten-Check bleibt möglich, sobald die TI verfügbar ist."
      },
      "selected_card_reader_unavailable": {
        "label": "Kartenleser",
        "fix": "Optional — Kartenleser auswählen oder anschließen."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Optional — Praxisausweis (SMC-B) stecken."
      }
    },
    "token": {
      "title": "SOLTOKEN eintragen",
      "description": "Der QR-Code enthält aus Sicherheitsgründen kein SOLTOKEN. Kopieren Sie es in der inSuite unter Sol-Aktivierung (FrontDesk+) und fügen Sie es hier ein.",
      "submit": "Weiter",
      "rescan": "Code erneut scannen"
    }
  },
  "common": {
    "back": "Zurück",
    "next": "Weiter",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "done": "Fertig",
    "retry": "Erneut versuchen",
    "clear": "Löschen",
    "close": "Schließen",
    "verifying": "Überprüfe...",
    "select": "Auswählen",
    "minutes": "Minuten",
    "clock": "Uhr",
    "gender": {
      "M": "Männlich",
      "W": "Weiblich",
      "D": "Divers",
      "U": "Unbekannt"
    },
    "insurance": {
      "GKV": "Gesetzlich",
      "PKV": "Privat",
      "SELFPAY": "Selbstzahler"
    },
    "scroll-up": "Nach oben scrollen",
    "scroll-down": "Nach unten scrollen"
  },
  "settings": {
    "device-reset": {
      "title": "Gerät zurücksetzen",
      "description": "Verbindung zur Praxis, Geräte-Einstellungen und Geheimzahl auf diesem Gerät löschen.",
      "confirmation": "Dieses Gerät muss danach neu eingerichtet werden. Die SOL-Konfiguration und Patientendaten in inSuite bleiben unverändert.",
      "cancel": "Abbrechen",
      "confirm": "Jetzt zurücksetzen"
    },
    "title": "Einstellungen",
    "save": "Speichern",
    "save-success": "Einstellungen gespeichert",
    "save-error": "Fehler beim Speichern",
    "load-error": "Fehler beim Laden der Einstellungen",
    "pin": {
      "title": "PIN-Eingabe erforderlich",
      "description": "Bitte geben Sie Ihre PIN ein, um die Einstellungen zu öffnen.",
      "error": "Falsche PIN. Bitte erneut versuchen.",
      "backspace": "Letzte Ziffer löschen"
    },
    "connection": {
      "title": "Verbindung",
      "description": "Verbindung zur Doc-Cirrus-Bridge der Praxis",
      "bridge-url": "Bridge-Adresse",
      "device-name": "Gerätename",
      "device-name-placeholder": "z.B. Empfang, Zimmer 1, Kiosk",
      "device-name-hint": "Unter diesem Namen erscheint das Gerät in der Bridge-Übersicht.",
      "kim-address": "KIM-Adresse (optional)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "Nur für dieses Gerät. Leer lassen, um die KIM-Adresse der Praxis zu verwenden.",
      "test": "Testen",
      "success": "Verbindung erfolgreich",
      "error": "Verbindung fehlgeschlagen",
      "api-unreachable": "DocCirrus API nicht erreichbar",
      "status-title": "Verbindungsstatus",
      "status": {
        "api": "API verbunden",
        "ti": "Telematik-Infrastruktur",
        "card-reader": "Kartenleser verfügbar",
        "medical-card": "Praxiskarte (SMC-B/HBA)"
      },
      "kim-address-consequence": "Beim Check-in per QR-Code erhält diese Adresse die Versichertendaten der Krankenversicherung – statt der Praxis-Adresse.",
      "kim-address-practice": "Praxis-Adresse (Standard)",
      "kim-address-confirm-title": "KIM-Adresse für dieses Gerät ändern?",
      "kim-address-confirm-description": "Beim Check-in per QR-Code sendet die Krankenversicherung die Versichertendaten künftig an diese Adresse.",
      "kim-address-confirm-previous": "Bisher",
      "kim-address-confirm-next": "Neu",
      "kim-address-confirm-cancel": "Abbrechen",
      "kim-address-confirm-accept": "Adresse ändern",
      "sol-token": "Sol-Token (aus inSuite)",
      "sol-token-hint": "Aus der Bridge-Verwaltung in inSuite kopieren. Wird für die Verbindung benötigt.",
      "sol-token-show": "Token anzeigen",
      "sol-token-hide": "Token verbergen",
      "bridge-unreachable": "Bridge nicht erreichbar. Bitte Adresse und Port prüfen.",
      "diagnostic-id": "Diagnose-ID: {{id}}",
      "scan-qr": "QR-Code scannen",
      "scan-title": "Bridge-QR-Code scannen",
      "scan-manual": "Manuell eingeben"
    },
    "terminal": {
      "title": "Kartenleser",
      "description": "Kartenleser für die Gesundheitskarte an diesem Gerät",
      "select": "Kartenleser",
      "select-placeholder": "Kartenleser wählen",
      "loading": "Kartenleser werden geladen …",
      "none-available": "Keine Kartenleser verfügbar",
      "none-found": "Keine Kartenleser gefunden",
      "found": "{{count}} Terminal(s) gefunden",
      "connect-hint": "Testen Sie zuerst die Verbindung, um die Kartenleser zu laden.",
      "found-count": "Gefundene Kartenleser: {{count}}",
      "refresh": "Kartenleser neu laden"
    },
    "practice": {
      "title": "Praxis",
      "description": "Informationen zu Ihrer Praxis",
      "name": "Praxisname",
      "name-placeholder": "z.B. Dr. med. Max Mustermann",
      "welcome-message": "Willkommensnachricht",
      "welcome-placeholder": "z.B. Willkommen in unserer Praxis",
      "scheduler-available": "Terminkalender aktivieren",
      "scheduler-available-description": "Patienten können Termine über das Self-Service-Terminal buchen",
      "prescription-available": "Rezeptservice aktivieren",
      "prescription-available-description": "Patienten können Folgerezepte am Self-Service-Terminal anfragen. Die Praxis prüft jede Anfrage.",
      "welcome-hint": "Leer lassen: Die Begrüßung erscheint in der Sprache der Patient:innen. Ein eigener Text wird in jeder Sprache unverändert gezeigt."
    },
    "patient-info": {
      "eyebrow": "Patientendaten-Prüfung",
      "description": "Gilt praxisweit für alle FrontDesk+ Terminals. Änderungen werden serverseitig durchgesetzt.",
      "enabled": "Prüfung nach dem Einlesen der eGK anzeigen",
      "phone": "Telefonnummern prüfen",
      "email": "E-Mail-Adressen prüfen",
      "hausarzt": "Hausarzt prüfen",
      "selection-required": "Wählen Sie mindestens eine Angabe aus.",
      "save": "Prüfung speichern",
      "saved": "Prüfung gespeichert.",
      "conflict": "Die Einstellung wurde zwischenzeitlich geändert. Der aktuelle Stand wurde geladen.",
      "save-error": "Die Prüfung konnte nicht gespeichert werden.",
      "unavailable": "Die praxisweite Einstellung ist derzeit nicht verfügbar.",
      "scope": "Praxisweit · Server",
      "scope-description": "Wird auf dem Server der Praxis gespeichert und für alle Terminals durchgesetzt.",
      "sentence-off": "Die Prüfung ist ausgeschaltet. Patient:innen werden am Terminal nicht nach ihren Kontaktdaten gefragt.",
      "last-saved": "Zuletzt serverseitig gespeichert: {{value}}",
      "never-saved": "Noch nie serverseitig gespeichert.",
      "last-saved-all": "Für alle Geräte gespeichert am {{value}}",
      "never-saved-default": "Standard-Einstellung, bisher nicht geändert."
    },
    "anamnesis": {
      "title": "Digitale Anamnese",
      "description": "Zeigt nach dem Check-in einen Link und QR-Code zu Ihrem Anamnese-Anbieter.",
      "enabled": "Anamnese-Link nach Check-in anzeigen",
      "enabled-description": "Zeigt nach abgeschlossenem Check-in einen Link und QR-Code zu Ihrem Anamnese-Anbieter (z. B. Nelly).",
      "url": "Link zum Anamnese-Anbieter",
      "url-hint": "Der Link ist statisch und für alle Patient:innen gleich.",
      "preview-label": "Vorschau auf dem Abschluss-Bildschirm",
      "preview-note": "Der Link ist statisch und für alle Patient:innen gleich.",
      "url-first": "Zum Einschalten zuerst einen gültigen Link eingeben."
    },
    "appearance": {
      "title": "Erscheinungsbild",
      "description": "Anpassung der Benutzeroberfläche",
      "language": "Sprache",
      "default-kiosk-language": "Standard-Sprache für Patienten",
      "default-kiosk-language-hint": "Sprache, in der neue Kiosk-Sitzungen für Patienten starten.",
      "voice-over-volume": "Sprachassistent Lautstärke",
      "voice-over-hint": "Regelt die Lautstärke der Sprachausgabe für barrierefreie Bedienung.",
      "language-first": "Sprachauswahl zu Sitzungsbeginn anzeigen"
    },
    "security": {
      "title": "Sicherheit",
      "description": "PIN für den Zugang zu den Einstellungen",
      "pin": "PIN",
      "pin-hint": "4-8 Ziffern. Mindestens 4 Ziffern, nicht 0000."
    },
    "eyebrow": "Kiosk-Verwaltung",
    "nav": {
      "general": "Allgemein",
      "flows": "Funktionen",
      "anamnese": "Digitale Anamnese",
      "device": "Gerät & Verbindung"
    },
    "flows": {
      "title": "Funktionen am Terminal"
    },
    "language": {
      "title": "Sprache & Sprachausgabe",
      "description": "Sprache und Vorlesen für Patient:innen an diesem Gerät."
    }
  },
  "self-service": {
    "title": "Selbstbedienung",
    "step-progress": "Schritt {{current}} / {{total}}",
    "flows": {
      "checkin": "Anmeldung",
      "scheduler": "Terminbuchung",
      "prescription": "Rezepte",
      "locations": "Lageplan",
      "emergency": "Notfall"
    },
    "audio-guide": {
      "on": "Ton an",
      "off": "Ton aus",
      "replay": "Ansage wiederholen",
      "replay-unavailable": "Keine Ansage zum Wiederholen verfügbar"
    },
    "language-selector": {
      "title": "Sprache wählen",
      "description": "Bitte wählen Sie Ihre bevorzugte Sprache"
    },
    "settings": "Einstellungen",
    "start": {
      "welcome": "Willkommen",
      "subtitle": "Womit können wir Ihnen helfen?",
      "check-in-label": "Hauptweg",
      "check-in-cta": "Termin einchecken",
      "check-in-description": "Karte einstecken — fertig.",
      "check-in-hint": "Karte bereithalten",
      "scheduler-label": "Neu",
      "scheduler-cta": "Termin buchen",
      "scheduler-description": "Freien Termin aussuchen.",
      "location-plan": "Lageplan",
      "location-plan-description": "Finden Sie den Weg zu Ihrem Behandlungsraum.",
      "prescription-label": "Rezept",
      "prescription-cta": "Rezept anfragen",
      "prescription-description": "Folgerezept bei der Praxis anfragen.",
      "emergency-cta": "Lokaler Notfallton",
      "emergency-description": "Nur an diesem Gerät hörbar – ruft keine Hilfe.",
      "tap-to-start": "Antippen zum Starten"
    },
    "offline": {
      "banner-title": "Anmeldung vorübergehend nicht verfügbar",
      "banner-message": "Bitte wenden Sie sich an den Empfang.",
      "emergency-available": "Der lokale Notfallton bleibt verfügbar. Er ruft keine Hilfe.",
      "flow-disabled": "Vorübergehend nicht verfügbar"
    },
    "readability": {
      "toggle-label": "Lesemodus",
      "on": "Lesemodus",
      "off": "Lesemodus"
    },
    "reset-overlay": {
      "timeout-title": "Sitzung beendet",
      "timeout-subtitle": "Ihre Zeit ist abgelaufen. Ihre Daten sind sicher.",
      "offline-title": "Verbindung unterbrochen",
      "offline-subtitle": "Die Verbindung wurde unterbrochen. Bitte wenden Sie sich an den Empfang.",
      "interruption-title": "Sitzung beendet",
      "interruption-subtitle": "Ihre Sitzung wurde sicher beendet.",
      "completion-title": "Vielen Dank!",
      "completion-subtitle": "Ihr Vorgang wurde erfolgreich abgeschlossen.",
      "reassurance": "Ihre persönlichen Daten werden nicht auf diesem Gerät gespeichert.",
      "auto-dismiss": "Startbildschirm in {{seconds}} Sekunden...",
      "dismiss": "Zum Start"
    },
    "timed-terminal": {
      "countdown": "Automatische Rückkehr in {{seconds}} Sekunden",
      "countdown-outcome": "Dieses Terminal kehrt danach automatisch zum Startbildschirm zurück.",
      "more-time": "Mehr Zeit",
      "extended": "Zeit verlängert"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Diese Fragen sind in Ihrer Sprache nicht verfügbar. Bitte wählen Sie eine angebotene Sprache oder wenden Sie sich an die Anmeldung.",
        "alternatives": "Alternative Termine",
        "loading": "Fragen werden geladen …",
        "reception-fallback": "Bitte wenden Sie sich an den Empfang.",
        "error-title": "Die Fragen konnten nicht geladen werden",
        "language-unavailable-lead": "Diese Fragen gibt es nicht in Ihrer Sprache.",
        "language-unavailable-title": "Bitte wählen Sie eine dieser Sprachen",
        "language-unavailable-body": "Oder lassen Sie sich am Empfang helfen."
      },
      "start": {
        "title": "Termin buchen",
        "subtitle": "Buchen Sie in wenigen Schritten Ihren Wunschtermin",
        "welcome": "Willkommen zur Terminbuchung",
        "description": "Wir führen Sie durch den Buchungsprozess",
        "cta": "Termin jetzt buchen"
      },
      "patient-id": {
        "title": "Identifikation",
        "subtitle": "Bitte identifizieren Sie sich",
        "mode-card": "Mit Karte",
        "mode-search": "Suchen",
        "mode-create": "Neu anlegen",
        "insert-card": "Bitte stecken Sie Ihre Versichertenkarte ein",
        "reading-card": "Karte wird gelesen...",
        "simulate-card": "Karte simulieren",
        "multiple-matches": "Mehrere Patienten gefunden. Kartendaten werden verwendet.",
        "search-placeholder": "Name oder Versichertennummer...",
        "searching": "Suche läuft...",
        "no-results": "Keine Ergebnisse gefunden",
        "first-name": "Vorname",
        "last-name": "Nachname",
        "dob": "Geburtsdatum",
        "insurance": "Versicherung",
        "continue": "Fortfahren",
        "creating": "Patient wird angelegt...",
        "patient-created": "Patient erfolgreich angelegt!",
        "create-error": "Fehler beim Anlegen des Patienten."
      },
      "appointment-type": {
        "title": "Terminart wählen",
        "subtitle": "Bitte wählen Sie den Grund Ihres Besuchs",
        "loading": "Lade Terminarten...",
        "no-types": "Keine Terminarten verfügbar",
        "no-bookable": "Diese Terminarten können am Kiosk aktuell nicht gebucht werden. Bitte wenden Sie sich an die Anmeldung oder vereinbaren Sie den Termin telefonisch.",
        "disabled-default": "Bitte vereinbaren Sie diesen Termin direkt am Empfang oder telefonisch.",
        "disabled-footer": "Nur vor Ort/telefonisch",
        "error": "Terminarten konnten nicht geladen werden. Bitte erneut versuchen.",
        "lead": "Welche Art von Termin möchten Sie buchen?",
        "duration": "ca. {{minutes}} Minuten",
        "empty-title": "Hier können gerade keine Termine gebucht werden",
        "none-bookable-title": "Diese Termine können Sie hier nicht buchen",
        "none-bookable-body": "Bitte fragen Sie am Empfang oder rufen Sie uns an."
      },
      "types": {
        "general": "Allgemeine Sprechstunde",
        "general-desc": "Für allgemeine Beschwerden und Fragen",
        "checkup": "Vorsorgeuntersuchung",
        "checkup-desc": "Regelmäßige Gesundheitschecks",
        "vaccination": "Impfung",
        "vaccination-desc": "Impftermin vereinbaren",
        "followup": "Nachuntersuchung",
        "followup-desc": "Kontrolltermin",
        "prescription": "Rezept",
        "prescription-desc": "Rezeptabholung"
      },
      "slot-selection": {
        "title": "Termin auswählen",
        "subtitle": "Bitte wählen Sie einen freien Termin",
        "loading": "Lade freie Termine...",
        "no-slots": "Keine freien Termine verfügbar",
        "no-appointment-type": "Keine Terminart ausgewählt",
        "error": "Freie Termine konnten nicht geladen werden. Bitte erneut versuchen.",
        "quick-select": "Nächste freie Termine:",
        "select-date": "Oder wählen Sie ein Datum:",
        "times-for": "{{date}}",
        "available": "Verfügbar",
        "unavailable": "Keine Termine",
        "slots": "Termine",
        "select-time-hint": "Tippen Sie auf eine Uhrzeit, um Ihren Termin zu buchen",
        "week-short": "KW",
        "weekday-mon": "Mo",
        "weekday-tue": "Di",
        "weekday-wed": "Mi",
        "weekday-thu": "Do",
        "weekday-fri": "Fr",
        "weekday-sat": "Sa",
        "weekday-sun": "So",
        "period-morning": "Vormittag",
        "period-midday": "Mittag",
        "period-afternoon": "Nachmittag",
        "period-evening": "Abend",
        "period-morning-short": "Vorm.",
        "period-midday-short": "Mitt.",
        "period-afternoon-short": "Nachm.",
        "period-evening-short": "Abend",
        "period-dots-legend": "Zeitverfügbarkeit",
        "filter-hint": "Nach bevorzugten Zeiten filtern:",
        "or-choose-below": "oder unten selbst wählen",
        "no-slots-period": "Keine Slots",
        "show-all": "Alle anzeigen",
        "free": "frei",
        "your-selection": "Ihre Auswahl",
        "oclock": "Uhr",
        "choose-slot": "Slot wählen",
        "choose-day": "Tag wählen",
        "choose-day-first": "Bitte wählen Sie zuerst einen Tag",
        "times-heading": "Freie Zeiten am {{date}}",
        "time-value": "{{time}} Uhr",
        "empty-title": "Keine freien Termine im {{month}}",
        "empty-body": "Sehen Sie im nächsten Monat nach oder fragen Sie am Empfang – wir helfen Ihnen gern.",
        "next-month": "Nächster Monat",
        "previous-month": "Vorheriger Monat"
      },
      "confirmation": {
        "patient-responses": "Ihre Angaben",
        "review-loading": "Zusammenfassung wird geprüft …",
        "review-unavailable": "Zusammenfassung nicht verfügbar. Bitte versuchen Sie es erneut oder fragen Sie am Empfang.",
        "check-booking": "Buchungsstatus prüfen",
        "title": "Termin bestätigen",
        "subtitle": "Bitte überprüfen Sie Ihre Buchung",
        "patient": "Patient",
        "datetime": "Datum und Uhrzeit",
        "booking": "Buche...",
        "confirm": "Termin buchen",
        "heading": "Sieht das gut aus?",
        "lead": "Bitte bestätigen Sie Ihren Termin.",
        "appointment": "Termin",
        "insured-via": "Versichert über",
        "description-label": "Hinweise für die Praxis (optional)",
        "description-hint": "Teilen Sie uns mit, wenn wir bei der Terminvergabe oder beim Check-in etwas beachten sollen.",
        "description-placeholder": "z. B. eingeschränkte Mobilität, Begleitperson, wichtige Hinweise",
        "description-too-long": "Bitte kürzen Sie den Hinweis auf höchstens 500 Zeichen.",
        "summary": "Zusammenfassung",
        "change": "Ändern",
        "book-binding": "Termin verbindlich buchen",
        "cancel": "Abbrechen",
        "type-label": "Terminart",
        "datetime-value": "{{date}} um {{time}} Uhr",
        "name-label": "Name",
        "insurance-label": "Versicherung",
        "insurance-GKV": "Gesetzlich versichert",
        "insurance-PKV": "Privat versichert",
        "insurance-SELFPAY": "Selbstzahler",
        "change-time": "Termin ändern",
        "description-free-text": "Weitere Hinweise (optional)",
        "note-wheelchair": "Ich nutze einen Rollstuhl",
        "note-companion": "Ich komme mit Begleitung",
        "note-interpreter": "Ich brauche eine Übersetzung"
      },
      "done": {
        "title": "Termin gebucht!",
        "label": "Gebucht",
        "subtitle": "Ihr Termin wurde erfolgreich gebucht.",
        "date": "Datum",
        "time": "Uhrzeit",
        "booking-id": "Buchungsnummer",
        "qr-hint": "Zum Kalender hinzufügen",
        "qr-description": "Scannen Sie diesen QR-Code mit Ihrer Smartphone-Kamera, um den Termin zu Ihrer Kalender-App hinzuzufügen",
        "auto-redirect": "Sie werden in Kürze zur Startseite weitergeleitet...",
        "auto-redirect-countdown": "Zurück zum Start in {{seconds}} Sekunden...",
        "back-to-start": "Zurück zum Start",
        "print-button": "Terminzettel drucken",
        "print-preparing": "Druckansicht wird vorbereitet…",
        "print-error": "Der Terminzettel konnte nicht geöffnet werden. Bitte versuchen Sie es erneut oder wenden Sie sich an die Rezeption.",
        "print-returned": "Die System-Druckansicht wurde geschlossen. Bei Bedarf können Sie eine weitere Kopie anfordern.",
        "print-title": "Ihr Termin",
        "print-location": "Ort",
        "print-map-hint": "Standort mit dem Smartphone öffnen",
        "print-error-v2": "Der Terminzettel konnte nicht geöffnet werden. Bitte versuchen Sie es erneut oder fragen Sie am Empfang."
      },
      "error": {
        "assistance-info": "Wir konnten Ihre Buchung nicht bestätigen. Ihr Termin ist vielleicht schon gebucht. Bitte fragen Sie am Empfang nach.",
        "pending-title": "Buchung nicht bestätigt",
        "pending-info": "Wir konnten Ihre Buchung nicht bestätigen. Ihr Termin ist vielleicht schon gebucht. Bitte prüfen Sie es erneut oder fragen Sie am Empfang nach.",
        "title": "Buchung fehlgeschlagen",
        "subtitle": "Der Termin konnte leider nicht gebucht werden.",
        "info": "Bitte versuchen Sie es erneut oder fragen Sie am Empfang."
      },
      "phase": {
        "identify": "Anmelden",
        "choose": "Termin wählen",
        "confirm": "Bestätigen"
      }
    },
    "prescription": {
      "start": {
        "title": "Rezepte & Bestellservice",
        "subtitle": "Legen Sie Ihre Versichertenkarte ein, um Rezepte einzusehen oder Folgerezepte zu bestellen.",
        "button": "Karte einlegen"
      },
      "card-check": {
        "loading": "Kartenleser wird geladen...",
        "no-terminal": "Kein Kartenleser konfiguriert",
        "no-terminal-hint": "Bitte wenden Sie sich an das Personal.",
        "insert-card": "Bitte legen Sie Ihre Karte ein",
        "insert-card-hint": "Legen Sie Ihre Versichertenkarte in den Kartenleser ein.",
        "card-detected": "Karte erkannt",
        "reading": "Karte wird gelesen...",
        "reading-hint": "Bitte warten Sie einen Moment.",
        "error": "Fehler beim Lesen der Karte",
        "retry": "Erneut versuchen",
        "manual-lookup": "Ohne Karte fortfahren",
        "load-error": "Kartenleser konnte nicht geladen werden",
        "read-error": "Die Karte konnte nicht gelesen werden"
      },
      "patient-selection": {
        "title": "Patient auswählen",
        "subtitle": "Es wurden mehrere Patienten gefunden. Bitte wählen Sie Ihren Namen.",
        "try-again": "Erneut versuchen",
        "try-again-hint": "Karte erneut einlegen"
      },
      "list": {
        "title": "Ihre Rezepte",
        "for-patient": "Rezepte für {{name}}",
        "loading": "Rezepte werden geladen...",
        "error-title": "Fehler beim Laden",
        "fetch-error": "Rezepte konnten nicht geladen werden",
        "back-home": "Zurück zum Start",
        "done": "Fertig"
      },
      "detail": {
        "prescription-info": "Rezeptinformationen",
        "date": "Datum",
        "prescriber": "Arzt",
        "comment": "Hinweis",
        "medications": "Medikamente",
        "form": "Darreichung",
        "pack-size": "Packungsgröße",
        "manufacturer": "Hersteller",
        "loading": "Rezept wird geladen...",
        "fetch-error": "Rezeptdetails konnten nicht geladen werden",
        "back-to-list": "Zurück zur Übersicht",
        "print": "Drucken"
      },
      "types": {
        "public": "Kassenrezept",
        "private": "Privatrezept",
        "long-term": "Dauerrezept",
        "btm": "BTM-Rezept",
        "g": "Grünes Rezept",
        "t": "T-Rezept"
      },
      "no-patient": {
        "title": "Patient nicht gefunden",
        "subtitle": "Leider konnte kein Patient zu dieser Karte gefunden werden. Bitte wenden Sie sich an das Personal.",
        "try-again": "Erneut versuchen",
        "back-home": "Zurück zum Start",
        "title-v2": "Keine passenden Daten gefunden",
        "subtitle-v2": "Wir konnten Sie nicht finden. Bitte versuchen Sie es erneut oder fragen Sie am Empfang."
      },
      "done": {
        "title": "Vielen Dank",
        "subtitle": "Sie können jetzt Platz nehmen. Bei Fragen wenden Sie sich bitte an das Personal.",
        "no-prescriptions-title": "Keine Rezepte hinterlegt",
        "no-prescriptions-subtitle": "Für Sie sind aktuell keine aktiven Rezepte hinterlegt. Wenn Sie ein Rezept erwarten, wenden Sie sich bitte an das Personal am Empfang.",
        "error-title": "Ein Fehler ist aufgetreten",
        "error-subtitle": "Bitte wenden Sie sich an das Personal für weitere Hilfe.",
        "auto-redirect": "Automatische Weiterleitung in {{seconds}} Sekunden",
        "finish": "Zurück zum Start"
      },
      "hub": {
        "title": "Ihre Rezepte",
        "for-patient": "Rezepte für {{name}}",
        "loading": "Rezepte werden geladen...",
        "error-title": "Fehler beim Laden",
        "fetch-error": "Rezepte konnten nicht geladen werden",
        "back-home": "Zurück zum Start",
        "done": "Fertig",
        "order-button": "Rezept bestellen",
        "existing-prescriptions": "Ihre aktuellen Rezepte",
        "no-prescriptions": "Keine aktiven Rezepte vorhanden."
      },
      "patient-lookup": {
        "title": "Patient suchen",
        "subtitle": "Geben Sie Ihren Namen und Ihr Geburtsdatum ein.",
        "last-name": "Nachname",
        "first-name": "Vorname",
        "date-of-birth": "Geburtsdatum",
        "lastname": "Nachname",
        "lastname-placeholder": "Ihr Nachname",
        "firstname": "Vorname",
        "firstname-placeholder": "Ihr Vorname",
        "dob": "Geburtsdatum",
        "search": "Suchen",
        "searching": "Suche läuft...",
        "search-error": "Fehler bei der Suche: {{message}}",
        "no-match": "Kein Patient gefunden. Bitte prüfen Sie Ihre Eingabe.",
        "error": "Fehler bei der Suche. Bitte versuchen Sie es erneut.",
        "found": "Patient gefunden",
        "confirm": "Bestätigen",
        "ambiguous": "Mehrere Übereinstimmungen",
        "ambiguous-hint-firstname": "Bitte geben Sie auch Ihren Vornamen ein, um die Suche zu verfeinern.",
        "ambiguous-hint-additional": "Bitte prüfen Sie Ihre Eingabe oder wenden Sie sich an das Personal.",
        "not-found": "Patient nicht gefunden",
        "not-found-hint": "Unter diesen Angaben konnte kein Patient gefunden werden.",
        "not-found-action": "Erneut versuchen"
      },
      "manual-identification": {
        "unverified": "Ihre Identität wurde nicht mit der Gesundheitskarte bestätigt. Die Praxis prüft Ihre Angaben und die Anfrage vor der Bearbeitung."
      },
      "medication-selection": {
        "title": "Rezept anfragen",
        "subtitle": "Die Praxis prüft Ihre Anfrage. Nach Freigabe liegt das eRezept in Ihrer E-Rezept-App bereit.",
        "back": "Zurück",
        "submit": "Weiter zur Prüfung",
        "reason-title": "Warum brauchen Sie das Rezept?",
        "reason-hint": "Hilft der Praxis bei der Einschätzung.",
        "reason-validation": "Bitte wählen Sie ein Anliegen aus.",
        "reason-schmerzen": "Schmerzen",
        "reason-entzuendung": "Entzündung",
        "reason-nachsorge": "Nach OP / Eingriff",
        "reason-allergie": "Allergie / Reaktion",
        "reason-chronisch": "Chronische Erkrankung",
        "reason-anderes": "Etwas anderes",
        "medications-title": "Welche Medikamente?",
        "request-hint": "Beschreiben Sie, was Sie brauchen, oder nennen Sie das frühere Rezept, das erneuert werden soll.",
        "request-placeholder": "z. B. Ibuprofen 600 mg, wie beim letzten Mal",
        "request-validation": "Bitte beschreiben Sie, welches Medikament Sie benötigen.",
        "history-title": "Frühere Rezepte",
        "history-hint": "Übernehmen Sie einen Eintrag direkt in Ihre Anfrage.",
        "history-loading": "Frühere Rezepte werden geladen...",
        "history-error": "Frühere Rezepte konnten nicht geladen werden.",
        "history-add": "Übernehmen",
        "history-added": "Übernommen",
        "history-date": "Zuletzt: {{date}}",
        "history-request-line": "Folgerezept: {{medicationName}}",
        "urgency-title": "Wie dringend ist es?",
        "urgency-hint": "Hilft der Praxis bei der Priorisierung.",
        "urgency-soon": "Dringend",
        "urgency-soon-meta": "So bald wie möglich",
        "urgency-tomorrow": "Bald",
        "urgency-tomorrow-meta": "In den nächsten Tagen",
        "urgency-week": "Diese Woche",
        "urgency-week-meta": "Kein Zeitdruck",
        "lead": "Die Praxis prüft Ihre Anfrage. Nach der Freigabe finden Sie Ihr E-Rezept in der E-Rezept-App oder auf Ihrer Gesundheitskarte.",
        "history-hint-v2": "Tippen Sie auf ein früheres Rezept, um es zu übernehmen.",
        "history-retry": "Erneut laden"
      },
      "request-review": {
        "title": "Bestellung prüfen",
        "subtitle": "Bitte prüfen Sie Ihre Rezeptanfrage.",
        "request-label": "Gewünschtes Medikament",
        "selected-medications": "Ausgewählte Medikamente",
        "free-text-medications": "Weitere Medikamente",
        "freetext-label": "Sonstige",
        "quarterly-warning": "Ihre Gesundheitskarte wurde dieses Quartal noch nicht eingelesen. Die Praxis wird Sie ggf. kontaktieren.",
        "egk-warning": "Ihre Gesundheitskarte wurde dieses Quartal noch nicht eingelesen. Die Praxis wird Sie ggf. kontaktieren.",
        "submit": "Absenden",
        "submitting": "Wird gesendet...",
        "submit-error": "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
        "egk-proof-required": "Rezeptanfragen sind nur nach erfolgreichem Einlesen der Gesundheitskarte möglich. Bitte wenden Sie sich an das Personal.",
        "back": "Zurück",
        "reason-label": "Anliegen",
        "urgency-label": "Dringlichkeit",
        "completion-email-choice": "Ich möchte eine E-Mail erhalten, sobald die Praxis meine Anfrage bearbeitet hat.",
        "completion-email-label": "E-Mail-Adresse",
        "completion-email-placeholder": "name@beispiel.de",
        "completion-email-hint": "Nur für diese einmalige Nachricht. Die Adresse wird nicht als Stammdatum gespeichert.",
        "completion-email-invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        "title-v2": "Anfrage prüfen",
        "completion-email-hint-v2": "Die Adresse wird nur für diese eine Nachricht genutzt."
      },
      "confirmation": {
        "title": "Anfrage gesendet",
        "subtitle": "Ihre Rezeptanfrage wurde erfolgreich übermittelt.",
        "success-title": "Anfrage gesendet",
        "success-subtitle": "Ihre Rezeptanfrage wurde erfolgreich übermittelt.",
        "estimated-time": "Ihr Rezept wird voraussichtlich in {{time}} bereit sein.",
        "info": "Sie können Ihr Rezept in der Apotheke mit Ihrer Gesundheitskarte oder der eRezept-App abrufen.",
        "auto-redirect": "Automatische Weiterleitung in {{seconds}} Sekunden",
        "back-to-start": "Zurück zum Start",
        "handling-label": "Bearbeitung durch die Praxis",
        "next-steps": "Die Praxis prüft Ihre Anfrage. Nach der Freigabe können Sie Ihr E-Rezept mit Ihrer Gesundheitskarte oder der E-Rezept-App in der Apotheke einlösen."
      },
      "phase": {
        "identify": "Anmelden",
        "request": "Anfrage",
        "review": "Prüfen"
      }
    },
    "check-in": {
      "flow-label": "Check-in",
      "has-appointment": {
        "eyebrow": "Termin",
        "title": "Haben Sie heute einen Termin bei uns?",
        "subtitle": "Wenn Sie nicht sicher sind, wählen Sie einfach „Nicht sicher“ — wir finden Sie in unserem Kalender.",
        "yes-label": "Ja",
        "yes": "Ich habe einen Termin",
        "yes-description": "Wir finden ihn anhand Ihrer Karte oder Ihres Namens.",
        "yes-hint": "Schnellster Weg",
        "unsure-label": "Vielleicht",
        "unsure": "Ich bin nicht sicher",
        "unsure-description": "Kein Problem — wir prüfen das gemeinsam für Sie.",
        "unsure-hint": "Wir suchen für Sie",
        "no-label": "Nein",
        "no": "Ich habe keinen Termin",
        "no-description": "Wir prüfen, ob heute noch ein freier Platz frei ist.",
        "no-hint": "Walk-in"
      },
      "card-check": {
        "eyebrow": "Versichertenkarte",
        "title": "Bitte stecken Sie Ihre Versichertenkarte ein.",
        "subtitle": "Bitte stecken Sie Ihre Versichertenkarte in das Lesegerät",
        "insert-title": "Stecken Sie Ihre Versichertenkarte in das Lesegerät.",
        "insert-detail": "Wir lesen Ihre Daten automatisch — Sie brauchen nichts weiter zu tun.",
        "other-ways": "Andere Wege",
        "no-card-hint": "Wenn Sie Ihre Karte gerade nicht dabei haben.",
        "pkv-hint": "Per QR-Code mit Ihrer Versicherungs-App.",
        "loading": "Lade Einstellungen...",
        "no-terminal": "Kein Kartenleser konfiguriert. Bitte wenden Sie sich an das Personal.",
        "checking": "Prüfe auf Karten...",
        "insert-prompt": "Karte bitte einstecken...",
        "card-detected": "Karte erkannt! Bereit zum Lesen.",
        "read-card": "Karte lesen",
        "simulate-insert": "Karte simulieren",
        "reading": "Karte wird gelesen...",
        "error": "Karte konnte nicht gelesen werden. Bitte erneut versuchen.",
        "read-error": "Kartendaten konnten nicht gelesen werden. Bitte erneut versuchen.",
        "settings-error": "Einstellungen konnten nicht geladen werden. Bitte erneut versuchen.",
        "no-card-prompt": "Keine Karte dabei?",
        "no-card-action": "Manuelle Suche",
        "connection-warning": "Verbindungsprobleme mit dem Kartenleser. Bitte warten...",
        "pkv-prompt": "Privat versichert? Online Check-in",
        "pkv-instruction": "Scannen Sie diesen QR-Code mit der App Ihrer privaten Krankenversicherung, um Ihre Daten digital zu übermitteln.",
        "pkv-continue": "Weiter zur manuellen Anmeldung",
        "unreadable-title": "Karte erkannt, aber keine Versichertendaten lesbar.",
        "unreadable-body": "Bitte versuchen Sie es erneut oder wenden Sie sich an die Rezeption. Sie können sich auch ohne Karte anmelden.",
        "unreadable-help": "Bitte versuchen Sie es noch einmal oder melden Sie sich ohne Karte an. Der Empfang hilft Ihnen gern.",
        "title-pkv": "Anmeldung per App",
        "title-reading": "Ihre Karte wird gelesen …",
        "title-unreadable": "Karte konnte nicht gelesen werden",
        "title-no-terminal": "Anmeldung ohne Karte",
        "no-terminal-body": "Der Kartenleser ist gerade nicht verfügbar. Bitte melden Sie sich ohne Karte an oder wenden Sie sich an den Empfang.",
        "reading-detail": "Bitte lassen Sie die Karte stecken. Das dauert nur einen Moment.",
        "other-ways-title": "Andere Möglichkeiten",
        "no-card-title": "Ohne Karte anmelden",
        "pkv-prompt-title": "Privat versichert?",
        "pkv-prompt-hint": "Anmeldung per App Ihrer privaten Krankenversicherung",
        "pkv-close": "Doch mit Karte anmelden",
        "pkv-instruction-app": "Öffnen Sie die App Ihrer privaten Krankenversicherung und scannen Sie diesen Code. Ihre Angaben kommen dann direkt zu uns."
      },
      "patient-selection": {
        "title": "Identifikation erforderlich",
        "subtitle": "Mehrere Patienten gefunden. Bitte geben Sie Ihren Vornamen ein, damit wir Sie zuordnen können.",
        "firstname-label": "Ihr Vorname",
        "firstname-placeholder": "Vorname eingeben...",
        "confirm-button": "Bestätigen",
        "no-match": "Kein passender Patient gefunden. Bitte wenden Sie sich an das Personal.",
        "still-ambiguous": "Es gibt weiterhin mehrere Treffer. Bitte wenden Sie sich an das Personal.",
        "select-error": "Fehler bei der Patientenzuordnung. Bitte versuchen Sie es erneut.",
        "staff-assist": "Zum Personal gehen",
        "title-v2": "Kurze Rückfrage",
        "subtitle-v2": "Bitte geben Sie zur Sicherheit Ihren Vornamen ein.",
        "no-match-v2": "Wir konnten Sie mit diesem Vornamen nicht finden. Bitte prüfen Sie die Schreibweise oder wenden Sie sich an den Empfang.",
        "still-ambiguous-v2": "Wir konnten Sie noch nicht eindeutig finden. Bitte wenden Sie sich an den Empfang.",
        "select-error-v2": "Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal."
      },
      "card-checkin": {
        "title": "Anmeldung bestätigen",
        "subtitle": "Ihre Daten wurden erfolgreich gelesen.",
        "confirm": "Anmeldung bestätigen"
      },
      "register-from-card": {
        "title": "Neuregistrierung",
        "subtitle": "Wir haben Ihre Daten von der Karte gelesen. Bitte überprüfen Sie diese und bestätigen Sie die Registrierung.",
        "card-data": "Kartendaten",
        "create": "Patient registrieren",
        "create-error": "Die Registrierung ist fehlgeschlagen. Bitte versuchen Sie es erneut oder wenden Sie sich an das Personal.",
        "staff-assist": "Personal rufen",
        "no-card-data-title": "Keine Kartendaten",
        "no-card-data": "Es konnten keine Daten von der Karte gelesen werden.",
        "insurance-verified": "Versicherung bestätigt: {{insurer}}",
        "insurer-missing": "Die Karte enthält keine Kostenträgerkennung. Eine Registrierung über die Karte ist nicht möglich. Bitte wenden Sie sich an die Rezeption.",
        "title-v2": "Ihre Angaben von der Karte",
        "subtitle-v2": "Bitte prüfen Sie Ihre Angaben. Wenn etwas nicht stimmt, tippen Sie auf „Ändern“.",
        "create-v2": "Angaben bestätigen",
        "create-error-v2": "Die Anmeldung hat leider nicht geklappt. Bitte versuchen Sie es noch einmal oder wenden Sie sich an den Empfang.",
        "insurer-missing-v2": "Auf Ihrer Karte fehlt die Angabe Ihrer Krankenkasse. Bitte wenden Sie sich an den Empfang.",
        "edit": "Ändern",
        "name": "Name",
        "insurer": "Krankenkasse"
      },
      "patient-lookup": {
        "title": "Patient suchen",
        "subtitle": "Bitte geben Sie Ihren Nachnamen und Ihr Geburtsdatum ein.",
        "lastname": "Nachname",
        "lastname-placeholder": "Ihr Nachname",
        "dob": "Geburtsdatum",
        "firstname": "Vorname",
        "firstname-placeholder": "Ihr Vorname",
        "search": "Suchen",
        "searching": "Suche läuft...",
        "search-placeholder": "Name oder Versichertennummer...",
        "results-placeholder": "Suchergebnisse werden hier angezeigt",
        "found": "Patient gefunden!",
        "confirm-identity": "Bitte bestätigen Sie, dass Sie der gefundene Patient sind.",
        "confirm-button": "Das bin ich",
        "ambiguous-firstname": "Mehrere Patienten gefunden. Bitte geben Sie Ihren Vornamen ein.",
        "ambiguous-additional": "Mehrere Patienten gefunden. Bitte wenden Sie sich an das Personal.",
        "disambiguation-hint": "Dies hilft uns, Sie eindeutig zu identifizieren.",
        "not-found": "Kein Patient mit diesen Daten gefunden.",
        "error": "Fehler bei der Suche: {{message}}",
        "staff-assist": "Personal rufen",
        "not-found-prompt": "Nicht gefunden?",
        "register-new": "Neu registrieren",
        "not-found-hint": "Unter diesen Angaben konnte kein Patient gefunden werden.",
        "create-new": "Neu registrieren",
        "dob-placeholder": "TT.MM.JJJJ",
        "dob-picker": "Geburtsdatum im Kalender auswählen",
        "title-v2": "Anmeldung ohne Karte",
        "subtitle-firstname": "Bitte geben Sie zusätzlich Ihren Vornamen ein.",
        "ambiguous-firstname-v2": "Es gibt mehrere Personen mit diesem Namen. Bitte geben Sie zusätzlich Ihren Vornamen ein.",
        "search-again": "Erneut suchen",
        "found-v2": "Wir haben Sie gefunden",
        "found-confirm": "Bitte bestätigen Sie mit „Das bin ich“.",
        "not-found-title": "Wir haben Sie nicht gefunden",
        "not-found-check": "Bitte prüfen Sie die Schreibweise und das Geburtsdatum. Der Empfang hilft Ihnen gern weiter.",
        "not-found-reception": "Bitte prüfen Sie die Schreibweise und das Geburtsdatum oder wenden Sie sich an den Empfang.",
        "ambiguous-additional-v2": "Wir konnten Sie nicht eindeutig finden. Bitte wenden Sie sich an den Empfang.",
        "error-v2": "Die Suche hat gerade nicht geklappt. Bitte versuchen Sie es noch einmal."
      },
      "checking-in": {
        "title": "Einen Moment — wir checken Sie ein.",
        "subtitle": "Wir tragen Sie in die Behandlungsliste ein und benachrichtigen das Team.",
        "step-insurance": "Versicherung geprüft",
        "step-appointment": "Termin bestätigt",
        "step-waitlist": "In Warteliste eintragen",
        "error": "Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "continue": "Trotzdem fortfahren",
        "title-v2": "Einen Moment bitte",
        "loading": "Wir melden Sie an …",
        "subtitle-v2": "Wir tragen Sie in die Warteliste ein und sagen dem Team Bescheid.",
        "error-title": "Das hat leider nicht geklappt",
        "error-v2": "Ihre Anmeldung konnte nicht abgeschlossen werden.",
        "error-body": "Bitte versuchen Sie es noch einmal. Wenn es wieder nicht klappt, hilft Ihnen der Empfang."
      },
      "appointment-selection": {
        "title": "Termin auswählen",
        "subtitle": "Sie haben heute mehrere Termine. Bitte wählen Sie einen aus.",
        "checking-in": "Anmeldung wird durchgeführt...",
        "time": "{{time}} Uhr",
        "error-v2": "Die Anmeldung für diesen Termin hat nicht geklappt. Bitte versuchen Sie es noch einmal oder wenden Sie sich an den Empfang."
      },
      "no-appointment": {
        "title": "Kein Termin gefunden",
        "subtitle": "Wir konnten heute keinen Termin für Sie finden. Bitte buchen Sie einen regulären Termin.",
        "book-appointment": "Termin buchen",
        "book-appointment-description": "Buchen Sie jetzt einen neuen Termin über die reguläre Terminvergabe.",
        "staff-assist": "Personal rufen",
        "staff-assist-description": "Ich benötige Unterstützung.",
        "booking-disabled": "Terminbuchung ist derzeit deaktiviert",
        "booking-disabled-description": "Bitte wenden Sie sich an das Praxispersonal, um einen Termin zu vereinbaren.",
        "back-to-start": "Zurück zum Start",
        "subtitle-v2": "Für heute haben wir keinen Termin für Sie gefunden.",
        "book-v2": "Neuen Termin vereinbaren",
        "book-v2-description": "Wählen Sie jetzt einen freien Termin aus.",
        "have-appointment": "Ich habe einen Termin",
        "have-appointment-description": "Der Empfang hilft Ihnen gern weiter.",
        "unavailable-title": "Termine vereinbaren Sie bitte am Empfang",
        "subtitle-unavailable": "Für heute haben wir keinen Termin für Sie gefunden. Bitte wenden Sie sich an den Empfang."
      },
      "staff-assist": {
        "title": "Personal wird informiert",
        "subtitle": "Ein Mitarbeiter wird Ihnen gleich helfen.",
        "message": "Bitte warten Sie hier. Ein Mitarbeiter wird in Kürze bei Ihnen sein.",
        "start-over": "Zurück zum Start",
        "auto-redirect": "Zurück zum Start in {{seconds}} Sekunden..."
      },
      "eeb-prompt": {
        "title": "Versicherung prüfen",
        "title-failed": "Prüfung fehlgeschlagen",
        "subtitle": "Wie möchten Sie Ihre Versicherung nachweisen?",
        "subtitle-failed": "Scannen Sie den QR-Code mit Ihrer Krankenkassen-App, um einen Nachweis anzufordern.",
        "verify-card": "Elektronisch prüfen",
        "verify-card-description": "Anfrage an Ihre Krankenkasse senden.",
        "select-insurer": "Versicherer auswählen",
        "select-insurer-description": "Manuelle Auswahl Ihres Versicherers.",
        "skip": "Überspringen",
        "eyebrow-chip": "Alternative",
        "eyebrow": "Check-in · Versicherungsnachweis (eEB)",
        "recommended": "Empfohlen",
        "qr-title": "Mit Ihrer Kassen-App scannen",
        "qr-description": "App Ihrer Krankenkasse öffnen und den Code scannen — die eEB kommt direkt zu uns.",
        "qr-address-label": "Senden an",
        "title-app": "Nachweis per App",
        "subtitle-app": "Ihre Krankenkasse kann uns den Nachweis auch direkt schicken. Wenn Sie fertig sind, tippen Sie auf „Weiter“."
      },
      "quarterly-check": {
        "title": "Versicherungsnachweis",
        "checking": "Wir prüfen Ihren aktuellen Versicherungsnachweis...",
        "error": "Die Prüfung konnte nicht durchgeführt werden.",
        "title-v2": "Ihre Versicherung",
        "checking-v2": "Wir prüfen Ihre Versicherung – einen Moment bitte.",
        "error-body": "Ihre Anmeldung ist erledigt. Ihre Versicherung klärt der Empfang mit Ihnen."
      },
      "insurer-prefilled": {
        "title": "Ihre Krankenkasse",
        "subtitle": "Bitte bestätigen Sie Ihre Versicherung für dieses Quartal.",
        "your-insurance": "Ihre Krankenkasse",
        "last-read": "Zuletzt eingelesen am {{date}}",
        "quarterly-notice": "Für die Abrechnung benötigen wir einen aktuellen Versicherungsnachweis für dieses Quartal.",
        "confirm-button": "Ja, das ist meine Krankenkasse",
        "change-button": "Ich bin anders versichert",
        "contact-title": "Elektronische Ersatzbescheinigung anfordern",
        "contact-description": "Rufen Sie Ihre Krankenkasse an und bitten um eine elektronische Ersatzbescheinigung für:",
        "contact-patient": "Patient/in",
        "contact-kim-address": "KIM-Adresse der Praxis",
        "contact-phone": "Telefon",
        "question": "Ist das Ihre Krankenkasse?",
        "quarterly-notice-v2": "Einmal im Vierteljahr brauchen wir einen Nachweis Ihrer Krankenkasse."
      },
      "insurer-search": {
        "title": "Krankenkasse auswählen",
        "subtitle": "Bitte suchen und wählen Sie Ihre gesetzliche Krankenkasse.",
        "placeholder": "Krankenkasse suchen...",
        "hint": "Geben Sie mindestens 2 Zeichen ein, um zu suchen.",
        "no-results": "Keine Krankenkasse gefunden.",
        "no-results-hint": "Prüfen Sie die Schreibweise oder versuchen Sie eine andere Suche.",
        "label": "Name Ihrer Krankenkasse",
        "search-error-v2": "Die Suche hat gerade nicht geklappt. Bitte versuchen Sie es noch einmal.",
        "app-alternative": "Lieber mit der App Ihrer Krankenkasse?"
      },
      "insurer-contact": {
        "title": "Versicherungsnachweis anfordern",
        "subtitle": "Bitte wählen Sie eine der folgenden Optionen.",
        "or": "oder",
        "option-eeb-title": "Elektronisch anfordern",
        "option-eeb-description": "Wenn der gesetzliche Ausnahmefall vorliegt, können Sie die Anfrage nach Ihrer Zustimmung an das Praxisteam übergeben.",
        "option-qr-title": "Mit App scannen",
        "option-qr-description": "Scannen Sie den QR-Code mit Ihrer Krankenkassen-App.",
        "option-call-title": "Selbst anrufen",
        "option-call-description": "Rufen Sie Ihre Krankenkasse an und bitten Sie um eine eEB für diese Praxis:",
        "phone": "Telefon",
        "phone-not-available": "Telefonnummer auf Ihrer Versichertenkarte",
        "patient-name": "Patient/in",
        "practice-kim": "KIM-Adresse der Praxis",
        "help-notice": "Bei Problemen wenden Sie sich bitte an unsere Anmeldung.",
        "submit-eeb-button": "Voraussetzungen prüfen",
        "contacted-button": "Ich habe angerufen",
        "contacted-button-countdown": "Zeit für Ihren Anruf ({{seconds}}s)",
        "go-to-counter-button": "Zur Anmeldung gehen",
        "qr-continue-button": "Ich habe gescannt",
        "qr-continue-button-countdown": "Zeit zum Scannen ({{seconds}}s)",
        "title-v2": "Nachweis Ihrer Krankenkasse",
        "subtitle-v2": "Am einfachsten geht es mit der App Ihrer Krankenkasse.",
        "subtitle-no-app": "Bitte wählen Sie, wie Ihre Krankenkasse uns den Nachweis schicken soll.",
        "option-eeb-description-v2": "Wir fragen bei Ihrer Krankenkasse für Sie an. Dafür brauchen wir Ihre Zustimmung.",
        "call-instruction": "Rufen Sie Ihre Krankenkasse an und bitten Sie, den Nachweis an unsere Praxis zu schicken.",
        "call-instruction-practice": "Rufen Sie Ihre Krankenkasse an und bitten Sie, den Nachweis an die Praxis {{practice}} zu schicken.",
        "done-button": "Erledigt – weiter",
        "done-button-countdown": "Erledigt – weiter (noch {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Einwilligung",
        "subtitle": "Wir benötigen Ihre Zustimmung zur elektronischen Versicherungsprüfung.",
        "insurance": "Ihre Krankenkasse",
        "consent-title": "Einwilligung zur Übermittlung der elektronischen Ersatzbescheinigung (eEB)",
        "consent-text": "Ich habe verstanden, dass meine Krankenkasse im Rahmen der elektronischen Ersatzbescheinigung (eEB) meine Versichertenstammdaten (z. B. Name, Geburtsdatum, Versicherungsnummer) über den sicheren Kommunikationsdienst KIM an die Praxis {{practiceName}} zur Vorlage als Versicherungsnachweis übermittelt. Ich willige in diese Übermittlung ein. Mir ist bekannt, dass ich diese Einwilligung jederzeit widerrufen kann, ohne dass dadurch meine Behandlung beeinträchtigt wird.",
        "withdrawal-notice": "Sie können diese Einwilligung jederzeit widerrufen.",
        "agree-button": "Ich stimme zu",
        "decline-button": "Nicht zustimmen",
        "treatment-notice": "Ihre Behandlung wird nicht von dieser Einwilligung beeinflusst.",
        "load-failed": "Die Angaben für die Einwilligung konnten nicht geladen werden. Sie können stattdessen den QR-Code mit Ihrer Kassen-App scannen.",
        "not-available": "Diese Anfrage ist hier gerade nicht möglich. Bitte wenden Sie sich an den Empfang.",
        "submit-failed": "Ihre Zustimmung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Empfang.",
        "title-v2": "Nachweis Ihrer Krankenkasse",
        "summary": "Ihre Krankenkasse schickt uns den Nachweis direkt. Dafür brauchen wir Ihre Zustimmung.",
        "confirm-first": "Bitte bestätigen Sie zuerst die Erklärung."
      },
      "qr-code": {
        "title": "Mit Krankenkassen-App scannen",
        "instruction-1": "Öffnen Sie die App Ihrer Krankenkasse und scannen Sie diesen QR-Code.",
        "instruction-2": "Die Praxis erhält dann automatisch Ihren Versicherungsnachweis.",
        "practice": "Praxis: {{name}}",
        "alternative-hint": "Alternativ: Nutzen Sie Ihre Krankenkassen-App",
        "instruction-app": "Öffnen Sie die App Ihrer Krankenkasse und scannen Sie diesen Code. Der Nachweis kommt dann direkt zu uns.",
        "staff-line": "Für das Praxisteam: {{address}}",
        "staff-line-practice": "Für das Praxisteam: {{name}} · {{address}}",
        "alternative-app": "Sie können den Nachweis auch mit der App Ihrer Krankenkasse anfordern: Öffnen Sie die App und scannen Sie diesen Code."
      },
      "register-basics": {
        "title": "Persönliche Daten",
        "subtitle": "Bitte geben Sie Ihre Daten ein.",
        "family-name": "Nachname",
        "given-name": "Vorname",
        "dob": "Geburtsdatum",
        "gender": "Geschlecht",
        "insurance-type": "Versicherungsart",
        "insurer-name": "Name Ihrer Versicherung",
        "insurer-name-placeholder": "z.B. Debeka, DKV, Allianz...",
        "gender-required": "Bitte wählen Sie eine Angabe aus."
      },
      "register-insurer": {
        "title": "Krankenkasse",
        "subtitle": "Bitte wählen Sie Ihre Krankenkasse aus.",
        "search-placeholder": "Krankenkasse suchen..."
      },
      "register-details": {
        "title": "Zusammenfassung",
        "subtitle": "Bitte überprüfen Sie Ihre Angaben.",
        "create": "Registrierung abschließen",
        "missing-data": "Bitte füllen Sie alle Pflichtfelder aus.",
        "create-error": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "policy-number": "Versichertennummer (optional)",
        "policy-number-placeholder": "Ihre Versichertennummer",
        "create-v2": "Anmeldung abschließen",
        "policy-number-hint": "Sie finden die Nummer auf der Karte Ihrer Versicherung."
      },
      "diff-review": {
        "eyebrow-chip": "Abgleich",
        "eyebrow": "Check-in · Daten von der Karte",
        "title": "Ihre Karte ist neuer als unsere Akte.",
        "subtitle": "Sollen wir Ihre Akte mit den Kartendaten aktualisieren?",
        "col-current": "Bisher in der Akte",
        "col-new": "Neu von der Karte",
        "new-badge": "neu",
        "field-fallback": "Feld",
        "note": "Aktualisierte Daten helfen uns, Sie korrekt abzurechnen und im Notfall zu erreichen.",
        "comparison-placeholder": "Vergleich wird hier angezeigt",
        "confirm": "Akte aktualisieren & einchecken",
        "apply-error": "Die Daten konnten nicht übernommen werden. Bitte versuchen Sie es erneut.",
        "retry": "Erneut versuchen",
        "skip": "Trotzdem fortfahren",
        "no-changes": "Keine Änderungen gefunden",
        "title-v2": "Ihre Angaben haben sich geändert",
        "subtitle-v2": "Auf Ihrer Karte stehen neuere Angaben. Sollen wir sie übernehmen?",
        "confirm-v2": "Übernehmen und anmelden",
        "keep": "Ohne Änderung anmelden",
        "col-current-v2": "Bisher",
        "col-new-v2": "Neu von der Karte",
        "value-yes": "Ja",
        "value-no": "Nein"
      },
      "insurance-selection": {
        "title": "Versicherungsart",
        "subtitle": "Bitte wählen Sie Ihre Versicherungsart.",
        "gkv": "Gesetzlich versichert",
        "gkv-description": "Mitglied einer gesetzlichen Krankenkasse.",
        "pkv": "Privat oder Selbstzahler",
        "pkv-description": "Privatversichert oder Selbstzahler.",
        "pkv-description-v2": "Private Krankenversicherung oder Sie zahlen selbst."
      },
      "eeb-request": {
        "title": "Anfrage erfasst",
        "subtitle": "Ihr Check-in kann abgeschlossen werden. Die Antwort von {{insurer}} kommt später in der Praxis an.",
        "verifying": "Ihre Anfrage wurde zur sofortigen Verarbeitung angenommen.",
        "success": "Ihre Anfrage wurde sicher an das Praxisteam übergeben.",
        "error": "Die Bestätigung der Anfrage ist nicht verfügbar.",
        "try-alternative": "Alternative Methode",
        "kim-load-error": "Die KIM-Adresse der Praxis konnte nicht geladen werden.",
        "kim-label": "Praxis · KIM",
        "non-blocking-note": "Dies bestätigt noch nicht den Eingang bei der Krankenkasse oder Ihren Versicherungsstatus.",
        "auto-continue": "Es geht in {{seconds}} Sekunden automatisch weiter.",
        "unavailable-title": "Das hat leider nicht geklappt",
        "unavailable-v2": "Ihre Anfrage an die Krankenkasse konnte nicht erfasst werden.",
        "unavailable-body": "Sie können den Nachweis mit der App Ihrer Krankenkasse schicken lassen oder ihn am Empfang klären.",
        "use-app": "Mit der App",
        "at-reception": "Am Empfang klären"
      },
      "self-pay": {
        "title": "Selbstzahler",
        "subtitle": "Sie werden als Selbstzahler behandelt.",
        "info": "Bitte beachten Sie, dass Sie die Behandlungskosten selbst tragen müssen.",
        "confirm": "Verstanden",
        "title-v2": "Sie zahlen selbst",
        "subtitle-v2": "Sie zahlen die Behandlung selbst.",
        "insured-after-all": "Doch versichert"
      },
      "done": {
        "title": "Eingecheckt.",
        "subtitle": "Bitte nehmen Sie Platz — wir rufen Sie auf, sobald es losgeht.",
        "finish": "Beenden",
        "done-label": "Fertig",
        "error-label": "Hinweis",
        "eyebrow": "Check-in · abgeschlossen",
        "queue-label": "Wartezimmer",
        "queue-title": "Bitte nehmen Sie Platz",
        "queue-meta": "Wir rufen Sie persönlich auf.",
        "success-title": "Anmeldung erfolgreich!",
        "success-subtitle": "Bitte nehmen Sie im Wartezimmer Platz. Sie werden aufgerufen.",
        "auto-redirect": "Sie werden in Kürze zur Startseite weitergeleitet...",
        "auto-redirect-countdown": "Zurück zum Start in {{seconds}} Sekunden...",
        "card-expired-title": "Karte abgelaufen",
        "card-expired-subtitle": "Ihre Versichertenkarte ist abgelaufen.",
        "card-expired-info": "Bitte wenden Sie sich an das Personal für weitere Hilfe.",
        "back-to-start": "Zurück zum Start",
        "anamnesis-title": "Anamnesebogen ausfüllen",
        "anamnesis-description": "Scannen Sie den QR-Code, um Ihren Anamnesebogen bequem an Ihrem Smartphone auszufüllen.",
        "title-confirm": "Vielen Dank!",
        "subtitle-confirm": "Sie haben Ihre Angaben bestätigt. Ihr Check-in ist abgeschlossen – bitte nehmen Sie im Wartezimmer Platz.",
        "title-saved": "Vielen Dank!",
        "subtitle-saved": "Ihre Änderungen sind verarbeitet. Der Empfang meldet sich, falls etwas offen ist. Bitte nehmen Sie im Wartezimmer Platz.",
        "title-skip": "Übersprungen",
        "subtitle-skip": "Kein Problem – Ihr Check-in ist abgeschlossen. Änderungen können Sie jederzeit am Empfang mitteilen.",
        "title-v2": "Sie sind angemeldet",
        "card-expired-info-v2": "Bitte wenden Sie sich an den Empfang."
      },
      "patient-info": {
        "loading": "Ihre Kontaktdaten werden geladen …",
        "review": {
          "title": "Kontaktdaten prüfen",
          "intro": "Stimmen diese Angaben noch? Die Prüfung ist freiwillig – Ihr Check-in ist bereits abgeschlossen.",
          "no-contacts": "Es sind keine Telefonnummern oder E-Mail-Adressen hinterlegt.",
          "all-correct": "Alles korrekt",
          "skip": "Überspringen",
          "primary": "Hauptkontakt",
          "protected": "Änderungen an diesem Kontakt prüft der Empfang.",
          "reveal": "Anzeigen",
          "hide": "Verbergen",
          "type": {
            "MOBILEPRIV": "Mobil (privat)",
            "PHONEPRIV": "Telefon (privat)",
            "MOBILEJOB": "Mobil (geschäftlich)",
            "PHONEJOB": "Telefon (geschäftlich)",
            "EMAILPRIV": "E-Mail (privat)",
            "EMAILJOB": "E-Mail (geschäftlich)"
          },
          "save": "Speichern",
          "save-failed": "Speichern nicht möglich – bitte den Empfang ansprechen.",
          "delete": "Löschen",
          "undo": "Rückgängig",
          "invalid": "Bitte prüfen Sie das Format.",
          "add": "Hinzufügen",
          "add-title": "Kontakt hinzufügen",
          "add-type": "Art",
          "add-value": "Wert eingeben",
          "hausarzt": "Hausarzt",
          "hausarzt-placeholder": "Name oder Praxis eingeben",
          "hausarzt-reception": "Änderungen an dieser Angabe prüft der Empfang.",
          "hausarzt-invalid": "Bitte geben Sie höchstens 120 Zeichen ein.",
          "category": {
            "phone": "Telefon",
            "email": "E-Mail",
            "hausarzt": "Hausarzt"
          },
          "category-empty": "Nicht hinterlegt",
          "primary-tag": "Hauptkontakt",
          "protected-chip": "Geschützt – Empfang prüft",
          "chip-direct": "Änderungen: direkt gespeichert",
          "chip-reception": "Änderungen: Empfang prüft",
          "chip-staged_one": "{{count}} Änderung vorgemerkt",
          "chip-staged_other": "{{count}} Änderungen vorgemerkt",
          "chip-will-add": "Wird hinzugefügt",
          "expand-phone_one": "{{count}} weitere Nummer anzeigen",
          "expand-phone_other": "{{count}} weitere Nummern anzeigen",
          "expand-email_one": "{{count}} weitere Adresse anzeigen",
          "expand-email_other": "{{count}} weitere Adressen anzeigen",
          "collapse-phone_one": "Weitere Nummer verbergen",
          "collapse-phone_other": "Weitere Nummern verbergen",
          "collapse-email_one": "Weitere Adresse verbergen",
          "collapse-email_other": "Weitere Adressen verbergen",
          "change": "Ändern",
          "close": "Schließen",
          "staged-removal": "Wird entfernt – Wert ausgeblendet",
          "stage-add": "Vormerken",
          "add-more-phone": "Weitere Nummer hinzufügen",
          "add-more-email": "Weitere Adresse hinzufügen",
          "invalid-phone": "Bitte eine gültige Telefonnummer eingeben.",
          "invalid-email": "Bitte eine gültige E-Mail-Adresse eingeben.",
          "hausarzt-previous": "bisher: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} Änderung",
          "balance-total_other": "{{count}} Änderungen",
          "balance-direct": "{{count}} direkt gespeichert",
          "balance-reception": "{{count}} prüft der Empfang",
          "proposal-open": "Neue Adresse vorschlagen",
          "proposal-placeholder": "Ihr Vorschlag",
          "proposal-discard": "Verwerfen",
          "proposal-hint": "Ihr Vorschlag geht an den Empfang – die Adresse wird nicht sofort geändert.",
          "title-v2": "Ihre Angaben prüfen",
          "balance-prefix": "Beim Speichern:",
          "balance-direct-v2": "Sofort gespeichert: {{count}}",
          "balance-reception-v2": "Prüft der Empfang: {{count}}",
          "chip-reception-v2": "Änderungen prüft unser Empfang",
          "chip-changed": "Geändert: {{count}}",
          "remove": "Entfernen",
          "example-email": "z. B. name@beispiel.de",
          "example-phone": "z. B. 0171 1234567",
          "intro-v2": "Ihre Anmeldung ist erledigt. Stimmen diese Angaben noch? Das Prüfen ist freiwillig.",
          "auto-hide": "Angezeigte Werte werden nach kurzer Zeit wieder verborgen."
        },
        "result": {
          "title": "Ergebnis",
          "continue": "Weiter",
          "outcome": {
            "updated": "Aktualisiert",
            "satisfied": "War bereits aktuell",
            "task-created": "An den Empfang gesendet",
            "not-saved": "Noch nicht gespeichert",
            "pending-retry": "Noch nicht gespeichert"
          },
          "retry": "Erneut versuchen",
          "removed": "Wurde entfernt",
          "cleared": "Wurde gelöscht",
          "task-note": "Nichts wurde überschrieben – der Empfang meldet sich bei Bedarf.",
          "not-saved-note": "Nichts wurde überschrieben. Bitte sprechen Sie den Empfang an.",
          "banner-unfinished": "Eine Angabe ist noch nicht gespeichert. Sie können es direkt an der Zeile erneut versuchen.",
          "banner-done": "Ihre Angaben sind verarbeitet.",
          "footer": "Alle übrigen Angaben bleiben unverändert.",
          "task-note-v2": "Diese Angabe haben wir an den Empfang weitergegeben.",
          "banner-done-v2": "Vielen Dank! Ihre Angaben sind bei uns angekommen.",
          "footer-v2": "Alle anderen Angaben bleiben, wie sie sind."
        },
        "expiry": {
          "notice": "Aus Datenschutzgründen endet die Prüfung in 2 Minuten. Ihr Check-in bleibt abgeschlossen.",
          "title": "Die Prüfung ist abgelaufen",
          "body": "Aus Datenschutzgründen wurden alle angezeigten und eingegebenen Werte gelöscht. Ihr Check-in ist weiterhin abgeschlossen – Sie müssen nichts wiederholen. Änderungen können Sie jederzeit am Empfang mitteilen.",
          "continue": "Zum Abschluss",
          "body-v2": "Aus Datenschutzgründen haben wir die Anzeige geschlossen. Ihre Anmeldung ist trotzdem erledigt. Änderungen können Sie jederzeit am Empfang mitteilen."
        }
      },
      "progress": {
        "identify": "Anmelden",
        "insurance": "Versicherung",
        "done": "Fertig"
      },
      "dob-format-hint": "Zum Beispiel 01.10.1980",
      "dob-required": "Bitte geben Sie Ihr Geburtsdatum ein.",
      "insurance-label": {
        "GKV": "Gesetzlich versichert",
        "PKV": "Privat versichert",
        "SELFPAY": "Selbst zahlend"
      }
    },
    "emergency": {
      "title": "Akuter Notfall!",
      "label": "Notfall",
      "subtitle": "Dieser Alarm ist nur vor Ort hörbar und hat keine Hilfe gerufen. Rufen Sie bei akuten oder möglicherweise lebensbedrohlichen Notfällen 112 an.",
      "call-emergency": "Rettungsdienst anrufen (112)",
      "stop-sound": "Ton stoppen",
      "play-sound": "Ton abspielen",
      "back-to-start": "Zurück zum Start",
      "headline": "Bitte sprechen Sie sofort das Personal am Empfang an. Bei Lebensgefahr rufen Sie 112."
    },
    "help-reception": "Hilfe vom Empfang",
    "help-reception-toast": "Bitte wenden Sie sich an den Empfang – wir helfen Ihnen gern.",
    "language-entry": {
      "title": "Sprache wählen"
    },
    "loading": "Wird geladen …",
    "step-progress-label": "Fortschritt",
    "step-progress-phase": "Abschnitt {{current}} von {{total}}: {{phase}}",
    "step-progress-substep": "Teil {{current}} von {{total}}",
    "step-progress-complete": "Abgeschlossen",
    "identification": {
      "title": "Wer sind Sie?",
      "lead": "Am schnellsten geht es mit Ihrer Gesundheitskarte. Sie können auch mit Ihrem Namen suchen.",
      "lead-card-only": "Bitte stecken Sie Ihre Gesundheitskarte in den Kartenleser.",
      "mode-label": "Wie möchten Sie sich anmelden?",
      "mode-card": "Mit Karte",
      "mode-search": "Mit Namen suchen",
      "mode-create": "Neu in der Praxis",
      "card": {
        "loading": "Kartenleser wird vorbereitet …",
        "checking": "Kartenleser wird geprüft …",
        "insert-title": "Bitte stecken Sie Ihre Gesundheitskarte in den Kartenleser.",
        "insert-detail": "Wir lesen Ihre Daten automatisch.",
        "detected": "Karte erkannt",
        "read": "Karte lesen",
        "reading": "Karte wird gelesen …",
        "reading-hint": "Bitte lassen Sie die Karte stecken.",
        "no-terminal-title": "Kartenleser nicht verfügbar",
        "help-with-search": "Bitte suchen Sie mit Ihrem Namen oder fragen Sie am Empfang.",
        "help-reception": "Bitte fragen Sie am Empfang – wir helfen Ihnen gern.",
        "unreadable-title": "Karte erkannt, aber nicht lesbar",
        "error-title": "Die Karte konnte nicht gelesen werden",
        "not-unique": "Wir konnten Sie mit der Karte nicht eindeutig zuordnen. Bitte suchen Sie mit Ihrem Namen oder fragen Sie am Empfang.",
        "no-match": "Zu dieser Karte haben wir keine passenden Daten gefunden. Bitte suchen Sie mit Ihrem Namen oder fragen Sie am Empfang.",
        "without-card": "Ohne Karte weiter"
      },
      "lookup": {
        "lead": "Bitte geben Sie Ihren Nachnamen und Ihr Geburtsdatum ein.",
        "first-name": "Vorname",
        "last-name": "Nachname",
        "dob": "Geburtsdatum",
        "dob-hint": "Format: TT.MM.JJJJ",
        "search": "Suchen",
        "confirm": "Ja, das bin ich",
        "found-title": "Wir haben Sie gefunden",
        "found-body": "Bitte bestätigen Sie, dass es um Sie geht.",
        "first-name-needed-title": "Bitte ergänzen Sie Ihren Vornamen",
        "first-name-needed-body": "Damit wir Sie eindeutig finden. Tippen Sie danach auf „Suchen“.",
        "ambiguous-title": "Wir konnten Sie nicht eindeutig finden",
        "ambiguous-body": "Bitte fragen Sie am Empfang – wir helfen Ihnen gern.",
        "not-found-title": "Keine passenden Daten gefunden",
        "not-found-body": "Bitte prüfen Sie Ihre Eingaben.",
        "error-title": "Die Suche ist gerade nicht möglich",
        "error-body": "Bitte versuchen Sie es erneut oder fragen Sie am Empfang."
      },
      "create": {
        "insurance-question": "Wie sind Sie versichert?",
        "insurance-required": "Bitte wählen Sie aus, wie Sie versichert sind.",
        "error-title": "Ihre Angaben konnten nicht gespeichert werden",
        "error-body": "Bitte versuchen Sie es erneut oder fragen Sie am Empfang."
      }
    }
  }
}
